import {
  FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL,
  FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_SUCCESS,
  FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_FAILURE,
} from './types';

const initialState = {
  isFetchingInitialDataForModal: false,
  enabledFlagValues: [],
  usTaxTypeValues: [],
  localTaxTypeValues: [],
  countryCodeValues: [],
  branchValues: [],
  sourceOptions: [],
  legalEntities: [],
};

function legalEntitySettings(state = initialState, action) {
  switch (action.type) {
    case FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL:
      return {
        ...state,
        isFetchingInitialDataForModal: true,
      };
    case FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_SUCCESS:
      return {
        ...state,
        isFetchingInitialDataForModal: false,
        enabledFlagValues: action.enabledFlagValues,
        usTaxTypeValues: action.usTaxTypeValues,
        localTaxTypeValues: action.localTaxTypeValues,
        countryCodeValues: action.countryCodeValues,
        branchValues: action.enabledFlagValues,
        sourceOptions: action.sourceOptions,
        legalEntities: action.legalEntities,
      };
    case FETCH_INITIAL_DATA_FOR_LEGAL_ENTITY_MODAL_FAILURE:
      return {
        ...state,
        isFetchingInitialDataForModal: false,
      };
    default:
      return state;
  }
}

export default legalEntitySettings;
